import { render, staticRenderFns } from "./CandidateStatusHeader.vue?vue&type=template&id=499fee0a&scoped=true&"
import script from "./CandidateStatusHeader.vue?vue&type=script&lang=js&"
export * from "./CandidateStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./CandidateStatusHeader.vue?vue&type=style&index=0&id=499fee0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499fee0a",
  null
  
)

export default component.exports